// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteModal__deleteModal___nVp9j {
    min-height: -moz-min-content;
    min-height: min-content;

    & span {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Modals/DialogModal/DeleteModal/DeleteModal.css"],"names":[],"mappings":"AAAA;IACI,4BAAuB;IAAvB,uBAAuB;;IAEvB;QACI,aAAa;QACb,8BAA8B;QAC9B,WAAW;IACf;AACJ","sourcesContent":[".deleteModal {\n    min-height: min-content;\n\n    & span {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteModal": `DeleteModal__deleteModal___nVp9j`
};
export default ___CSS_LOADER_EXPORT___;
